import { BlogLayout } from "./BlogLayout";
import { ArticleGrid } from "./ArticleCard";
import { useSeo } from "./useSeo";
import { MaskLine, Reveal } from "@/components/landing/Reveal";

export default function BlogIndex() {
  useSeo({
    title: "Blog sulla parodontite: sintomi, cure laser e prevenzione | Centro di Parodontologia",
    description: "Articoli del Dott. Nicola Mauro sulla parodontite (piorrea): sintomi da riconoscere, cura con il laser, prevenzione e come affrontare la paura del dentista.",
    path: "/blog",
  });
  return (
    <BlogLayout>
      <section className="mx-auto max-w-[1400px] px-6 sm:px-10 pt-20 pb-28" data-testid="blog-index">
        <p className="eyebrow text-[#3E6B48]">Il blog</p>
        <h1 className="f-serif text-5xl sm:text-6xl lg:text-7xl text-[#1B3B28] leading-[0.95] mt-4">
          <MaskLine>Capire le gengive,</MaskLine>
          <MaskLine delay={0.12}><em className="text-[#3E6B48]">con parole semplici.</em></MaskLine>
        </h1>
        <Reveal delay={0.2}><p className="text-[#526356] text-base sm:text-lg max-w-xl mt-8 leading-relaxed">Sintomi, cure e prevenzione della parodontite, spiegati con calma. Per arrivare alla prima visita più informato e più sereno.</p></Reveal>
        <div className="mt-16"><ArticleGrid /></div>
      </section>
    </BlogLayout>
  );
}
